import { render, staticRenderFns } from "./NavMenu.vue?vue&type=template&id=57a5b8fd&"
import script from "./NavMenu.vue?vue&type=script&lang=js&"
export * from "./NavMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57a5b8fd')) {
      api.createRecord('57a5b8fd', component.options)
    } else {
      api.reload('57a5b8fd', component.options)
    }
    module.hot.accept("./NavMenu.vue?vue&type=template&id=57a5b8fd&", function () {
      api.rerender('57a5b8fd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/sidebar/NavMenu.vue"
export default component.exports